var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 4.01002L3.63908 1.3335L4.53126 2.32436L1.55868 5.00088L0.666504 4.01002ZM7.33317 5.3335V9.3335H10.6665V8.00016H8.6665V5.3335H7.33317ZM1.99984 8.00016C1.99984 4.68646 4.68613 2.00016 7.99984 2.00016C11.3136 2.00016 13.9998 4.68646 13.9998 8.00016C13.9998 11.3139 11.3136 14.0002 7.99984 14.0002C4.68613 14.0002 1.99984 11.3139 1.99984 8.00016ZM3.33317 8.00016C3.33317 5.42284 5.42251 3.3335 7.99984 3.3335C10.5772 3.3335 12.6665 5.42284 12.6665 8.00016C12.6665 10.5775 10.5772 12.6668 7.99984 12.6668C5.42251 12.6668 3.33317 10.5775 3.33317 8.00016ZM15.3332 4.01002L12.3606 1.3335L11.4684 2.32436L14.441 5.00088L15.3332 4.01002Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.11c8b9238137768736c1e2f5cc20514b.svg";
export { ForwardRef as ReactComponent };